import React from "react";
import Card from "components/card";

const Widget = (props) => {
  const { icon, title, subtitle, extra } = props;

  return (
    <Card extra={`!flex-row flex-grow items-center rounded-2xl p-4 ${extra}`}>
      <div className="flex h-[70px] w-auto items-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-gray-100 bg-gray-50">
          <span className="flex h-7 w-7 items-center justify-center text-[#0055FF]">
            {icon}
          </span>
        </div>
      </div>

      <div className="ms-4 flex w-auto flex-col justify-center">
        <p className="text-[10px] uppercase tracking-widest text-gray-400">
          {title}
        </p>
        <h4 className="mt-1 text-xl text-gray-800">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;